import { Component, ChangeDetectionStrategy, Inject, ViewChild, ElementRef } from '@angular/core';
import { DialogHeaderComponent, DialogService, LoaderComponent } from '@mode/shared/ui';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { MAT_LEGACY_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { IconComponent, ButtonComponent, TooltipDirective } from '@mode/capra';
import { ISecret } from '@mode/notebooks/contract';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { NotebookSecretService } from '@mode/notebooks/domain';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    DialogHeaderComponent,
    DragDropModule,
    IconComponent,
    ButtonComponent,
    LoaderComponent,
    FormsModule,
    ReactiveFormsModule,
    TooltipDirective,
  ],
  selector: 'mode-notebook-secret-modal-edit',
  templateUrl: './notebook-secret-modal-edit.component.html',
  styleUrls: ['../modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotebookSecretModalEditComponent {
  @ViewChild('secretValueInput', { static: true }) secretValueInput: ElementRef | undefined;
  form: FormGroup;
  showPassword = false;
  secret: ISecret;
  get secretValue() {
    return this.form.get('secretValue');
  }
  get showValue() {
    return this.form.get('showValue');
  }

  constructor(
    private fb: FormBuilder,
    private dialogService: DialogService,
    private notebookSecretService: NotebookSecretService,
    @Inject(MAT_LEGACY_DIALOG_DATA)
    private data: {
      secret: ISecret;
    }
  ) {
    this.form = this.fb.group({
      secretKey: [
        {
          value: data.secret.key,
          disabled: true,
        },
      ],
      secretValue: ['', [Validators.required, Validators.maxLength(4096)]],
      showValue: [{ value: false, disabled: true }],
    });
    this.secretValue?.valueChanges.subscribe((value) => {
      if (value) {
        this.showValue?.enable();
      } else {
        this.showValue?.disable();
      }
    });
    this.secret = data.secret;
  }

  ngAfterViewInit() {
    this.secretValueInput?.nativeElement.focus();
  }

  onSubmit(): void {
    if (this.form.valid) {
      const { secretValue } = this.form.value;
      this.dialogService.closeAll();
      this.notebookSecretService.editSecret(this.secret.token, {
        key: this.secret.key,
        secret_value: secretValue,
      });
    }
  }
  close(): void {
    this.dialogService.closeAll();
  }

  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }
}
